export class LibererGroupDossier
{
    taskIdList:String[];
}